module.exports = __webpack_public_path__ + "files/221aaecb0f2c1c7dc9033cdd3e3ef96a.png";